import Vue from 'vue'
import routes from './routes'
import Router from 'vue-router'
import indexRoutes from './utils/index-routes'
import ga from 'vue-ga'

indexRoutes(routes)
Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes
});

ga(router, 'UA-97864362-1');

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js